export default "__VITE_ASSET__c2cc887b__"